export class YandexMetricsParameters {
    public static readonly CounterId = 91052163;
}
